import axios from 'axios';
import 'nprogress/nprogress.css';
import NProgress from 'nprogress';

NProgress.configure({ showSpinner: false });

const HTTP = axios.create({
//  baseURL: 'http://adrsearch.test/rest/',
  baseURL: '/',
  'X-Custom-Header': 'foobar',
  headers: {
    'Content-Type': 'application/json'
  }
});

const HTTPPlugin = {
  install(Vue, options) {
    var router = options;
    HTTP.interceptors.request.use((config)=> {
      var token = localStorage.getItem('user-token');

      if (token)
      config.headers = {
          'Authorization': 'Bearer ' + token
      }

      else {
        console.log("there is no token");
        router.push('/login');
        return Promise.reject(config);
      }

    	NProgress.start();
    	return config;
    }, (error) => {
      NProgress.done();
      return error;
    });

    HTTP.interceptors.response.use((response) => {
        if (response.status === 403 ) {
          localStorage.removeItem('user-token');
        this.$router.push(this.$route.query.redirect || '/login');
          throw new axios.Cancel('token error');
        }
        NProgress.done();
        return response;
      },(error)=> {
        NProgress.done();
        console.log('inspector error');
    	if (error.response.status == 403 ) {
        console.log('removed token');
        localStorage.removeItem('user-token');
      router.push('/login');
        console.log('redirected');
      }
    //
    	//return Promise.reject(error);
      return Promise.reject(error.response);
    });

    Vue.prototype.$http = HTTP;
  }
}

export default HTTPPlugin;
